import { THEME_NAMES } from "./config";

export const carrefourTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.carrefour,
  logoUrl: "https://cdn.nemuru.com/assets/logos/carrefour-logo.svg",
  palette: {
    primary: {
      main: "#00529c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ed1c24",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#f4f4f4",
      contrastText: "#121212",
      accent: "#003c72",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#00274a",
      primary: "#121212",
      secondary: "#666",
    },
    status: {
      active: "#4ac687",
      approved: "#349a65",
      analysing: "#00529c",
      sent: "#00274a",
      cancelled: "#d8d8d8",
      denied: "#e81e26",
    },
    info: {
      main: "#eaf9fa",
      contrastText: "#ffffff",
      light: "#d6dbdf",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#479d38",
      contrastText: "#ffffff",
      light: "rgba(76, 205, 138,0.6)",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  background: "#f4f4f4",
  customBorderRadius: {
    button: 3,
    paper: 3,
  },
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
